/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LoginRequest } from '../models/login-request';
@Injectable({
  providedIn: 'root',
})
class TokenService extends __BaseService {
  static readonly TokenCreatePath = '/token';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Creates JSON Web Token for authorization. This token is valid for the next 30 minutes
   * @param loginRequest Model with Username and Password of the user
   * @return OK
   */
  TokenCreateResponse(loginRequest: LoginRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = loginRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * Creates JSON Web Token for authorization. This token is valid for the next 30 minutes
   * @param loginRequest Model with Username and Password of the user
   * @return OK
   */
  TokenCreate(loginRequest: LoginRequest): __Observable<string> {
    return this.TokenCreateResponse(loginRequest).pipe(
      __map(_r => _r.body as string)
    );
  }
}

namespace TokenService {
}

export { TokenService }